import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validatePlayersSearch } from './lib/playersSearch';
import { validatePlayerDetailSearch } from './lib/playerSearch';

/**
 * ★ REFERENCE ROUTES ★
 *
 * Pages are loaded with `lazyRouteComponent`, so each module becomes its own JS
 * chunk. In an app that will end up with a dozen modules, that keeps the
 * initial bundle to the shell plus whatever screen the user actually opened.
 *
 * `validateSearch` is the reason TanStack Router is here: downstream,
 * `search.page` is a clamped `number` and `search.position` is one of the
 * backend's enum values, rather than the `string | null` every page would
 * otherwise re-parse and re-validate. With a filter bar this wide, that is the
 * difference between one validation site and a dozen.
 */
export const playersRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/players',
  component: lazyRouteComponent(() => import('./pages/PlayersListPage'), 'PlayersListPage'),
  validateSearch: validatePlayersSearch,
});

export const playerDetailRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/players/$playerId',
  component: lazyRouteComponent(() => import('./pages/PlayerDetailPage'), 'PlayerDetailPage'),
  // The open tab lives in the URL, so a link to one is shareable and a refresh
  // stays put. See lib/playerSearch.ts for why it is a param, not six routes.
  validateSearch: validatePlayerDetailSearch,
});

export const playersRoutes = [playersRoute, playerDetailRoute];
